import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getResearchCenterOptions } from '@/module/ResearchCenter';
import { ResearchCenterEdit } from '@/module/ResearchCenter/ResearchCenterEdit';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout/edit')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.edit' },
  },
});

function RouteComponent() {
  const { researchCenterId } = Route.useParams();
  const { data: researchCenter } = useSuspenseQuery(getResearchCenterOptions(researchCenterId));

  return <ResearchCenterEdit researchCenter={researchCenter} />;
}
